/**
 *
 * LoadingOverlay
 *
 */

import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

import styles from './styles.module.css';

type LoadingOverlayProps = {
  isLoading: boolean;
  showProgress: boolean;
  children: React.ReactNode;
};

export const LoadingOverlay = ({
  isLoading = false,
  showProgress = false,
  children,
}: LoadingOverlayProps) => (
  <div className={styles.wrapper}>
    <div
      className={styles.overlay}
      style={{
        opacity: isLoading ? 1 : 0,
        pointerEvents: isLoading ? 'initial' : 'none',
      }}
      data-test={isLoading ? 'loading-overlay' : 'loading-overlay-invisible'}
    >
      {showProgress && isLoading && (
        <CircularProgress aria-label="loading" size={60} />
      )}
    </div>
    {children}
  </div>
);

export default LoadingOverlay;
